import { render } from "./CadAtivacao.vue?vue&type=template&id=76cbbb3a&scoped=true"
import script from "./CadAtivacao.vue?vue&type=script&lang=js"
export * from "./CadAtivacao.vue?vue&type=script&lang=js"

import "./CadAtivacao.vue?vue&type=style&index=0&id=76cbbb3a&scoped=true&lang=css"
import "./CadAtivacao.vue?vue&type=style&index=1&id=76cbbb3a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76cbbb3a"]])

export default __exports__